// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3XxoD","left":"InfoRow_left__3X2eJ"};